/*@flow*/
import { useEffect } from 'react';
import useCachedQuery from 'lib/useCachedQuery';
import GetLayers from './queries/GetLayers';
import useBbox from './useBbox';
import queryUUIDPaths from './queryUUIDPaths';
import useCommands from './useCommands';
import Blank from 'lib/Blank';
import * as I from 'immutable';

type QueryPath = string;
type UUID = string;

function getLayerQueryKey(query: I.Map<string, any>): string {
  return queryUUIDPaths(query)
    .first()
    .join('|');
}

function mkLayerQueryToUUIDMap(layers: {}[] = []): I.Map<QueryPath, UUID> {
  return I.fromJS(layers)
    .toMap()
    .filter(v => v.get('query'))
    .mapKeys((k, v) => getLayerQueryKey(v.get('query')))
    .map(v => v.get('uuid'));
}

export default function useLayerLoader(): any {
  const bbox = useBbox();
  const variables = { bbox };
  const opts = { variables };
  const { data, ...rest } = useCachedQuery(GetLayers, opts);
  const layers = data.layers || [];
  const cmd = useCommands();
  useEffect(() => {
    if (Blank.is(layers)) return;
    const map = mkLayerQueryToUUIDMap(layers);
    cmd.set(['layersLoaded'], layers);
    // This is going to be useful when we're activating the layers
    // from the parts of the query string on initial load.
    cmd.set(['layersLoadedQueryMap'], map);
  }, [layers]);

  return { ...rest, data: layers };
}
